import { createFileRoute, useParams } from '@tanstack/react-router';

import { CourseAttendanceView } from '@/views/attendance/course-attendance-view.tsx';

// 学生考勤 tab（ADR-023）：只读的每登记簿出勤百分比 +
// 关注阈值 + 会话明细。studentVisible 门控在服务器端。
export const Route = createFileRoute('/_learner/courses_/$id/attendance')({
  component: AttendanceTab,
});

function AttendanceTab() {
  const { id } = useParams({ from: '/_learner/courses_/$id/attendance' });
  return <CourseAttendanceView courseId={id} />;
}
